import React from 'react';

// eslint-disable-next-line new-cap
const LayerContext = new React.createContext();
export default LayerContext;
